import { render, staticRenderFns } from "./gudang.vue?vue&type=template&id=2e7570a5"
import script from "./gudang.vue?vue&type=script&lang=js"
export * from "./gudang.vue?vue&type=script&lang=js"
import style0 from "./gudang.vue?vue&type=style&index=0&id=2e7570a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports